import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WinLossComponent } from './win-loss.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { ComponentsModule } from 'src/app/components/components.module';
import { DateDefaultFormatPipe } from 'src/app/pipes/date-format.pipe';



@NgModule({
  declarations: [
    WinLossComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    ComponentsModule,
    DateDefaultFormatPipe
  ],
  exports:[
    WinLossComponent
  ]
})
export class WinLossModule { }
